import { render, staticRenderFns } from "./DynamicAttributeOptionValue.vue?vue&type=template&id=90df2770&"
import script from "./DynamicAttributeOptionValue.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeOptionValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports